import SinglePropChainTracker from "../../prop-tracker-utils/single-prop-chain-tracker.js";
import ValueTrackerObjGen from "../../prop-tracker-utils/value-tracker-obj-gen.js";

const Types = [
    { name: "objects", slideProp: "animation" },
    { name: "materials", slideProp: "materialAnimation" },
];

class SlideAssets {
    constructor(wrapCtx, evtCtx) {
        this._trackers = {};
        this._assets = {};

        for (const { name, slideProp } of Types) {
            const tracker = new SinglePropChainTracker(evtCtx);
            const objGen = new ValueTrackerObjGen(wrapCtx, evtCtx, tracker);

            this._trackers[name] = tracker;
            this._assets[name] = objGen;
        }

        Object.freeze(this._assets);
    }

    get assets() { return this._assets; }

    track(slide) {
        if (slide) {
            for (const { name, slideProp } of Types) {
                this._trackers[name].track(slide.data, ["value", slideProp]);
            }
        } else {
            for (const { name } of Types) {
                this._trackers[name].track();
            }
        }
    }

    update() {
        for (const { name } of Types) {
            this._assets[name].update();
        }
    }
}

export default SlideAssets;
